import React, { useState, useEffect, useCallback } from 'react';
import { Card, CardBody, CardHeader, Select, SelectItem, Button, RadioGroup, Radio, ButtonGroup } from "@heroui/react";
import  NumberPairInput  from '../NumberPairInput/NumberPairInput';
import { BonePriorityList } from './BonePriorityList'
function findMovementRuleByBodyPart(part,data) {
    if (!data || !data.movementRules) {
        return "ignore";
    }
    var val=data.movementRules[part]
    if(val===undefined){
        const parts=findCombinedParts(part);
        val =data.movementRules[parts];
    }
    return val===undefined?"ignore":val;
}
function findMaxAngleLimitByBodyPart(part,data){
    if (!data || !data.maxAngleLimits) {
        return [0,0];
    }
    var val=data.maxAngleLimits[part]
    if(val===undefined){
        const parts=findCombinedParts(part);
        val =data.maxAngleLimits[parts];
    }
    return val===undefined?[0,0]:val;
}
function findCombinedParts(part) {
    var result=undefined;
    switch (part) {
        case "lShoulder":
        case "rShoulder":    
            result= "shoulders";
            break;
        case "lElbow":
        case "rElbow":
            result= "elbows";
            break;
        case "lWrist":
        case "rWrist":
            result= "wrists";
            break;
        case "lThigh":
        case "rThigh":
            result= "thighs";
            break;
        case "lKnee":
        case "rKnee":
            result= "knees";
            break;
        case "lAnkle":
        case "rAnkle":
            result= "ankles";
            break;
        default:
            break;
    }
    return result;
}

function findUncombinedBodyParts(bodyPart){
    let result=[];
    switch (bodyPart) {
        case "shoulders":
            result=["lShoulder","rShoulder"]
            break;
        case "elbows":
            result=["lElbow","rElbow"]
            break;
        case "wrists":
            result=["lWrist","rWrist"]
            break;
        case "thighs":
            result=["lThigh","rThigh"]
            break;
        case "knees":
            result=["lKnee","rKnee"]
            break;
        case "ankles":
            result=["lAnkle","rAnkle"]
            break;
        default:
            result=[bodyPart]
            break;
    }
    return result;
}

function generatePropertyPairs(key, replacements) {
    if (!Array.isArray(replacements) || replacements.length !== 2) {
        throw new Error('Replacements must be an array of two elements');
    }
    return { [key]: replacements };
}
function expandProperties(obj, keyPairs) {
    const result = {...obj};
    
    for (const [shortKey, [leftKey, rightKey]] of Object.entries(keyPairs)) {
        if (shortKey in result) {
            const value = result[shortKey];
            delete result[shortKey];
            result[leftKey] = value;
            result[rightKey] = value;
        }
    }
    
    return result;
}
function compactProperties(obj, keyPairs) {
    const result = {...obj};
    
    for (const [compactKey, [leftKey, rightKey]] of Object.entries(keyPairs)) {
        const leftExists = leftKey in result;
        const rightExists = rightKey in result;
        
        // Hanya proses jika kedua key ada
        if (leftExists && rightExists) {
            if (result[leftKey] === result[rightKey]) {
                result[compactKey] = result[leftKey];
                delete result[leftKey];
                delete result[rightKey];
            }
        }
        // Jika hanya satu yang ada, biarkan saja
    }
    
    return result;
}


//const combinedParts=["shoulders","elbows","wrists","thighs","knees","ankles"]
const movementRules = [
    {key: "move", label: "Move"},
    {key: "fixed", label: "Fixed"},
    {key: "ignore", label: "Ignore"},
];
const ReferenceMotion=({part,data,onChange})=>{
    const [selectedMovementRule,setSelectedMovementRule]=useState(findMovementRuleByBodyPart(part,data));

    const angleMax=findMaxAngleLimitByBodyPart(part,data);
    const [angels, setAngels] = useState(angleMax===undefined?[0,0]:angleMax);

    const [boneList, setBoneList] = useState(() => new BonePriorityList(data?.feedbackPriority || []));

    let priorities= Array.from({length: boneList.getList().length}, (_, i) =>({"key":i, "label":i.toString()}) );
    priorities.unshift({"key":-1,"label":"Ignore"});
    const priority=boneList.getBoneIndex(part);
    const [selectedPriority,setSelectedPriority]= useState(priority<0?undefined:priority.toString());
   


    const handleMovementRuleChange = useCallback((value) => {
        console.log('Movement rule changed to:', value);
        setSelectedMovementRule(value);
        
        // Auto-save immediately when user changes the value
        // Preserve all existing fields including videoPath, path, duration, etc.
        const updatedData = { 
            ...data,
            movementRules: { ...data.movementRules || {} },
            maxAngleLimits: { ...data.maxAngleLimits || {} },
            feedbackPriority: [...(data.feedbackPriority || [])]
        };
        
        // Ensure we don't send undefined values for important fields
       /*  if (updatedData.videoPath === undefined) {
            updatedData.videoPath = null;
        }
        if (updatedData.path === undefined) {
            updatedData.path = null;
        }
        if (updatedData.duration === undefined) {
            updatedData.duration = 0;
        }
        if (updatedData.format === undefined) {
            updatedData.format = "TSFrameLog";
        }
         */
        // Update movement rules directly with the new value
        let movRules = {...updatedData.movementRules};
        let maxAngel = {...updatedData.maxAngleLimits};
        const combPart = findCombinedParts(part);
        
        // If movement rule is "ignore", set max angles to [0, 0]
        const newAngels = value === "ignore" ? [0, 0] : angels;
        
        if(combPart !== undefined){
            const uncombParts = findUncombinedBodyParts(combPart);
            const keyPairs = generatePropertyPairs(combPart, uncombParts);
            movRules = expandProperties(movRules, keyPairs);
            movRules[part] = value; // Use the new value directly
            movRules = compactProperties(movRules, keyPairs);

            maxAngel = expandProperties(maxAngel, keyPairs);
            maxAngel[part] = newAngels; // Use newAngels instead of angels
            maxAngel = compactProperties(maxAngel, keyPairs);
        } else {
            movRules[part] = value; // Use the new value directly
            maxAngel[part] = newAngels; // Use newAngels instead of angels
        }
        
        // Update local state if movement rule is "ignore"
        if (value === "ignore") {
            setAngels([0, 0]);
        }
        
        updatedData.movementRules = movRules;
        updatedData.maxAngleLimits = maxAngel;
        updatedData.feedbackPriority = boneList.getDisplayList();
        
        onChange(part, updatedData, () => {
            const name = data?.name?.toUpperCase();
            if (name === "BEGIN") return 0;
            else if (name === "MIDDLE") return 1;
            else return 2;
        });
    }, [data, part, onChange, angels, boneList]);

    const handleAngelsChange = (newAngels) => {
        setAngels(newAngels);
        // Auto-save when angles change
        // Preserve all existing fields including videoPath, path, duration, etc.
        const updatedData = { 
            ...data,
            movementRules: { ...data.movementRules || {} },
            maxAngleLimits: { ...data.maxAngleLimits || {} },
            feedbackPriority: [...(data.feedbackPriority || [])]
        };
        
        // Ensure we don't send undefined values for important fields
       /*  if (updatedData.videoPath === undefined) {
            updatedData.videoPath = null;
        }
        if (updatedData.path === undefined) {
            updatedData.path = null;
        }
        if (updatedData.duration === undefined) {
            updatedData.duration = 0;
        }
        if (updatedData.format === undefined) {
            updatedData.format = "TSFrameLog";
        } */
        
        // Update angle limits directly with the new value
        let movRules = {...updatedData.movementRules};
        let maxAngel = {...updatedData.maxAngleLimits};
        const combPart = findCombinedParts(part);
        
        if(combPart !== undefined){
            const uncombParts = findUncombinedBodyParts(combPart);
            const keyPairs = generatePropertyPairs(combPart, uncombParts);
            movRules = expandProperties(movRules, keyPairs);
            movRules[part] = selectedMovementRule;
            movRules = compactProperties(movRules, keyPairs);

            maxAngel = expandProperties(maxAngel, keyPairs);
            maxAngel[part] = newAngels; // Use the new value directly
            maxAngel = compactProperties(maxAngel, keyPairs);
        } else {
            movRules[part] = selectedMovementRule;
            maxAngel[part] = newAngels; // Use the new value directly
        }
        
        updatedData.movementRules = movRules;
        updatedData.maxAngleLimits = maxAngel;
        updatedData.feedbackPriority = boneList.getDisplayList();
        
        onChange(part, updatedData, () => {
            const name = data?.name?.toUpperCase();
            if (name === "BEGIN") return 0;
            else if (name === "MIDDLE") return 1;
            else return 2;
        });
    };

    const handlePriorityChange = (e) => {
        const newVal = e.target.value;
        const newBoneList = new BonePriorityList([...boneList.getList()]);
        
        if(parseInt(newVal) === -1){
            newBoneList.remove(part);
            setSelectedPriority(undefined);
        } else {
            newBoneList.add(part, newVal);
            setSelectedPriority(newVal);
        }
        setBoneList(newBoneList);
        
        // Auto-save when priority changes
        // Preserve all existing fields including videoPath, path, duration, etc.
        const updatedData = { 
            ...data,
            movementRules: { ...data.movementRules || {} },
            maxAngleLimits: { ...data.maxAngleLimits || {} },
            feedbackPriority: [...(data.feedbackPriority || [])]
        };
        
        // Ensure we don't send undefined values for important fields
        /* if (updatedData.videoPath === undefined) {
            updatedData.videoPath = null;
        }
        if (updatedData.path === undefined) {
            updatedData.path = null;
        }
        if (updatedData.duration === undefined) {
            updatedData.duration = 0;
        }
        if (updatedData.format === undefined) {
            updatedData.format = "TSFrameLog";
        } */
        
        // Update movement rules and angle limits
        let movRules = {...updatedData.movementRules};
        let maxAngel = {...updatedData.maxAngleLimits};
        const combPart = findCombinedParts(part);
        
        if(combPart !== undefined){
            const uncombParts = findUncombinedBodyParts(combPart);
            const keyPairs = generatePropertyPairs(combPart, uncombParts);
            movRules = expandProperties(movRules, keyPairs);
            movRules[part] = selectedMovementRule;
            movRules = compactProperties(movRules, keyPairs);

            maxAngel = expandProperties(maxAngel, keyPairs);
            maxAngel[part] = angels;
            maxAngel = compactProperties(maxAngel, keyPairs);
        } else {
            movRules[part] = selectedMovementRule;
            maxAngel[part] = angels;
        }
        
        updatedData.movementRules = movRules;
        updatedData.maxAngleLimits = maxAngel;
        updatedData.feedbackPriority = newBoneList.getDisplayList();
        
        onChange(part, updatedData, () => {
            const name = data?.name?.toUpperCase();
            if (name === "BEGIN") return 0;
            else if (name === "MIDDLE") return 1;
            else return 2;
        });
    };
    


    useEffect(() => {
        // Sync movement rule
        const currentRule = findMovementRuleByBodyPart(part, data);
        setSelectedMovementRule(currentRule);
        
        // Sync angle limits
        const currentAngles = findMaxAngleLimitByBodyPart(part, data);
        setAngels(currentAngles);
        
        // Sync priority
        const currentPriority = new BonePriorityList(data?.feedbackPriority || []).getBoneIndex(part);
        setSelectedPriority(currentPriority < 0 ? undefined : currentPriority.toString());
        
        // Sync boneList
        setBoneList(new BonePriorityList(data?.feedbackPriority || []));
    }, [data, part]);



    return (<Card className={`"max-w-[400px] shadow-md " ${selectedMovementRule==="ignore"?"":"dark:bg-emerald-600"}`}>
        <CardHeader className="justify-between">
                    <div className="flex"><p>{data?.name?.toUpperCase() || 'UNKNOWN'}</p></div>
        </CardHeader>
        <CardBody className="flex flex-col gap-2">
            <div className="space-y-2">
                <label className="text-sm font-medium text-gray-700 dark:text-gray-300">Movement Rule</label>
                <ButtonGroup size="sm" variant="bordered">
                    {movementRules.map((rule) => (
                        <Button
                            key={rule.key}
                            size="sm"
                            variant={selectedMovementRule === rule.key ? "solid" : "bordered"}
                            color={selectedMovementRule === rule.key ? "primary" : "default"}
                            onPress={() => handleMovementRuleChange(rule.key)}
                            className="text-xs px-2"
                        >
                            {rule.label}
                        </Button>
                    ))}
                </ButtonGroup>
            </div>
            <NumberPairInput value={angels} onChange={handleAngelsChange} />
            <Select
                className="max-w-xs"
                selectedKeys={[selectedPriority]}
                label="Feedback Priority"
                placeholder="Choose Priority Value"
                onChange={handlePriorityChange}
                >
                {priorities.map((priority) => (
                    <SelectItem key={priority.key}>{priority.label}</SelectItem>
                ))}
            </Select>
        </CardBody>
    </Card>);
}
export default React.memo(ReferenceMotion,(prevProps, nextProps) => {
    return prevProps.data === nextProps.data && prevProps.part === nextProps.part;
  });